var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"rounded-full gif"},[_c('img',{attrs:{"alt":_vm.alt,"src":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }